import Vue from 'vue';

import I from '@/components/I.vue';
Vue.component('I', I);

import PGroup from '@/components/PGroup.vue';
Vue.component('PGroup', PGroup);

import PLabel from '@/components/PLabel.vue';
Vue.component('PLabel', PLabel);

import PValue from '@/components/PValue.vue';
Vue.component('PValue', PValue);

import Compass from '@/components/Compass.vue';
Vue.component('Compass', Compass);

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import Instructions from '@/presentations/Instructions.vue';
Vue.component('Instructions', Instructions);

import BalanceBK from '@/charts/Balance.vue';
import D009BK from '@/presentations/company_slides/D009.vue';
if (process.env.VUE_APP_BRAND === 'BK') {
    Vue.component('Balance', BalanceBK);
    Vue.component('D009', D009BK);
}

import BalanceGT from '@/charts/BalanceGT.vue';
import D009GT from '@/presentations/company_slides/D009GT.vue';
if (process.env.VUE_APP_BRAND === 'GT') {
    Vue.component('Balance', BalanceGT);
    Vue.component('D009', D009GT);
}
